import React from 'react';
import { Inbox } from 'lucide-react';
import Button from './Button';
import styles from './EmptyState.module.css';

export interface EmptyStateProps {
  icon?: React.ReactNode;
  /**
   * Optional URL to a decorative illustration shown above the title. When
   * provided, it REPLACES the lucide icon. Keep the aspect flexible — we clamp
   * the width and soften the edges so it blends into the page background.
   */
  illustration?: string;
  title?: React.ReactNode;
  message?: React.ReactNode;
  cta?: { label: React.ReactNode; onClick: () => void };
  children?: React.ReactNode;
  className?: string;
}

const DEFAULT_ICON = <Inbox size={32} strokeWidth={1.5} aria-hidden="true" />;

function EmptyState({ icon = DEFAULT_ICON, illustration, title, message, cta, children, className }: EmptyStateProps) {
  return (
    <div className={[styles.wrap, illustration ? styles.withIllustration : '', className ?? ''].filter(Boolean).join(' ')}>
      {illustration ? (
        <img src={illustration} alt="" className={styles.illustration} loading="lazy" decoding="async" />
      ) : (
        <div className={styles.icon} aria-hidden="true">{icon}</div>
      )}
      {title && <div className={styles.title}>{title}</div>}
      {message && <div className={styles.msg}>{message}</div>}
      {children}
      {cta && (
        <div className={styles.cta}>
          <Button variant="primary" onClick={cta.onClick}>{cta.label}</Button>
        </div>
      )}
    </div>
  );
}

export default EmptyState;
